import { ProtoBaseModel, attr } from '@square/dashboard-data/utils/ember-model-stubs';
export default ProtoBaseModel.extend({
  merchantCatalogToken: attr(String),
  legacyCogsIdIdentifier: attr(String),
  catalogVersion: attr(Number)
});